import React from "react"
import { Text, Flex } from "rebass"
import styled from "styled-components"

import colors from "../../config/colors.js"

const Quote = styled.p`
  color: ${props => props && props.color};
  font-size: 21px;
  font-family: Raleway, 'Helvetica Neue', Helvetica, Roboto, Arial, sans-serif;
  font-weight: normal;
  text-align: center;
`

const Author = styled.p`
  color: ${props => props && props.color};
  font-size: 14px;
  font-family: Raleway, 'Helvetica Neue', Helvetica, Roboto, Arial, sans-serif;
  font-style: italic;
  font-weight: 700;
`

const SliderPanel = ({ testimonial, bg, color }) => (
  <Flex
    flexDirection="column"
    style={{ minHeight: "100px" }}
    bg={bg}
    py={4}
    mb={6}
  >
    <Quote color={color}>"{testimonial.body}"</Quote>
    <Author color={color}>- {testimonial.author}</Author>
  </Flex>
)

export default SliderPanel



// WEBPACK FOOTER //
// ./src/components/SliderPanel/index.js